<template>
    <div class="comment-wrapper">
        <!-- 添加回答/评论 -->
        <div class="smart-button" @click="onWriteComment">
            <img src="../../images/community/edit.png" alt="">
            <span>{{ isAnswer ? '添加回答' : '添加评论' }}</span>
        </div>
        <!-- 全部回答/评论 -->
        <div class="all-answer">
            <p>
                {{ '全部' + ( isAnswer ? '回答' : '评论') + ' ( ' }}
                <span class="answer-num">{{ commentListCount }}</span>
                {{ ' )' }}
            </p>
            <ul class="sort-list">
                <li
                    v-for="(item, index) in sortList"
                    :key="index"
                    :class="{'active': sortType === item.sort }"
                    @click="onSwitchSort(item)">
                    {{ item.value }}
                </li>
            </ul>
        </div>
        <!-- 评论区 -->
        <ul class="comment-list" v-loading="isLoading && !totalPage">
            <!-- 添加回复 -->
            <li class="comment-item my-comment" v-if="isWriteComment">
                <div class="user-avatar">
                    <img src="../../images/personal_center/avatar_default.png" v-if="curUserInfo.avatar.indexOf('?') === 0" @click="goUserPage(curUserInfo.user_id)">
                    <img :src="curUserInfo.avatar" v-else @click="goUserPage(curUserInfo.user_id)">
                </div>
                <div class="comment-content">
                    <p class="nick-name">{{ curUserInfo.nick_name }}</p>
                    <!-- 富文本 -->
                    <change-editor
                        class="comment-editor"
                        domId="commentEditor"
                        :isFullScreen="true"
                        :questionValue="filterXSS(commentContent)"
                        @onChangeEditor="onChangeEditor">
                    </change-editor>
                    <div class="send-msg">
                        <span class="cancel-btn" @click="onCancelComment(false)">取消</span>
                        <span :class="['comment-btn', {'disabled': !isAllowComment}]" @click="onConfirmComment">
                            {{ isAnswer ? '提交回答' : '提交' }}
                        </span>
                    </div>
                </div>
            </li>
            <!-- 评论列表 -->
            <li :class="`comment-item comment${item.id}`" v-for="(item, index) in commentList" :key="index">
                <div class="user-avatar">
                    <el-popover
                        popper-class="user-card"
                        placement="top"
                        :open-delay="500"
                        width="400"
                        trigger="hover"
                        @show="$refs['card' + item.commented_by.id + index][0].getUserInfo()">
                        <div style="text-align: right; margin: 0, padding: 0">
                            <user-card :ref="`card${item.commented_by.id}${index}`" :user-id="item.commented_by.id"></user-card>
                        </div>
                        <div slot="reference" class="user-avatar" @click="visible = !visible">
                            <img src="../../images/personal_center/avatar_default.png" v-if="item.commented_by.user_logo.indexOf('?') === 0" @click="goUserPage(item.commented_by.user_id)">
                            <img :src="item.commented_by.user_logo" v-else @click="goUserPage(item.commented_by.user_id)">
                        </div>
                    </el-popover>
                    <div :class="['approval', {'active': item.is_vote_up}]" @click="agreeInfo(item)">
                        <span class="num">{{ item.vote_up_num > 99 ? '100+' : item.vote_up_num || '0' }}</span>
                        <span>{{ item.is_vote_up ? '已赞' : '赞同' }}</span>
                    </div>
                </div>
                <div :class="['comment-content', {'show-replay': item.replyShow}]">
                    <div class="user-info">
                        <div class="user-name" @click="goUserPage(item.commented_by.user_id)"><span class="nick-name">{{item.commented_by.nick_name}}</span></div>
                        <el-tooltip v-if="item.commented_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                            <svg style="width: 20px; height: 20px" aria-hidden="true">
                                <use xlink:href="#icon-lanjingguanfang"></use>
                            </svg>
                        </el-tooltip>
                        <el-tooltip v-if="item.commented_by.is_vip" effect="light" content="核心用户" placement="right">
                            <span class="icon-vipuser"></span>
                        </el-tooltip>
                        <span class="adopted" v-if="item.is_accept">已采纳</span>
                        <span class="author" v-if="judgmentIsAuthor(item)">作者</span>
                    </div>
                    <div  :class="['comment', {'comment-height': item.showMore}]">
                        <p class="comment-value" style="word-break: break-word;" v-html="filterXSS(item.comment)" @click.stop="getImgUrl($event)"></p>
                        <p :class="['show-more', {'put-away': !item.showMore}]" v-if="item.exceed" @click="getMoreComment(item.id)">
                            <span>{{ item.showMore ? '显示更多' : '收起' }}</span>
                            <i :class="[item.showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i>
                        </p>
                    </div>
                    <p
                        class="show-more fixed-bottom"
                        v-if="fixedCommentId === item.id"
                        :style="getCommentCollapsePos()"
                        @click="getMoreComment(item.id)">
                        收起
                        <i class="el-icon-arrow-up"></i>
                    </p>
                    <div class="comment-footer">
                        <div class="interact">
                            <p :class="['reply', {'is-disabled': item.commentShowType === 'edit'}]" @click="getReplyList(item)">
                                <span>
                                    {{ item.replyShow && item.commentShowType === 'comment' ? '收起回复' : '回复' }}
                                </span>
                                <span class="number">
                                    {{ ' ( ' }}
                                    <i>{{item.comment_num || '0'}}</i>
                                    {{ ' )' }}
                                </span>
                            </p>
                            <p class="cancel-adoption" v-if="detailInfo.myself && isAnswer" @click="onSwitchAccept(item)">
                                <span>{{ item.is_accept ? '取消采纳' : '采纳回答' }}</span>
                            </p>
                            <template v-if="item.is_mine">
                                <p
                                    :class="['delete-comment', {'is-disabled': item.comment_num || item.replyShow}]"
                                    @click="deleteComment(item)">
                                    删除
                                </p>
                                <p
                                    :class="['edite-comment', {'is-disabled': item.comment_num || item.commentShowType === 'comment'}]"
                                    @click="onEditComment(item)">
                                    {{ item.commentShowType === 'edit' ? '取消编辑' : '编辑' }}
                                </p>
                            </template>
                        </div>
                        <span class="time">{{ item.created_on }}</span>
                    </div>
                    <!-- 回复区 -->
                    <ul class="reply-list" v-if="item.replyShow">
                        <!-- 添加回复 -->
                        <li class="comment-reply">
                            <div class="input-div" v-if="!item.isShowEditor">
                                <img @click="goUserPage(curUserInfo.user_id)" width="30" height="30" src="../../images/personal_center/avatar_default.png" v-if="curUserInfo.avatar.indexOf('?') === 0">
                                <img @click="goUserPage(curUserInfo.user_id)" width="30" height="30" :src="curUserInfo.avatar" v-else>
                                <div class="input" @click="item.isShowEditor = true">点击发表评论</div>
                            </div>
                            <reply
                                v-else
                                :replyInfo="item"
                                :userInfo="curUserInfo"
                                :isAnswer="isAnswer"
                                @onChangeEditor="onChangeEditor"
                                @replyComment="replyComment"
                                @onCancelComment="onCancelComment">
                            </reply>
                        </li>
                        <!-- 回复列表 -->
                        <template v-if="item.commentShowType !== 'edit'">
                            <li :class="[`reply-item comment${reply.id}`]" v-for="(reply, index) in replyList[item.id]" :key="index">
                                <div class="reply-box">
                                    <el-popover
                                        popper-class="user-card"
                                        placement="top"
                                        :open-delay="500"
                                        width="400"
                                        trigger="hover"
                                        @show="$refs['card-child' + reply.commented_by.user_id + index][0].getUserInfo()">
                                        <div style="text-align: right; margin: 0, padding: 0">
                                            <user-card :ref="`card-child${reply.commented_by.user_id}${index}`" :user-id="reply.commented_by.user_id"></user-card>
                                        </div>
                                        <div slot="reference" class="user-avatar">
                                            <div class="reply-user-avatar">
                                                <img @click="goUserPage(reply.commented_by.user_id)" width="30" height="30" src="../../images/personal_center/avatar_default.png" v-if="reply.commented_by.user_logo.indexOf('?') === 0">
                                                <img @click="goUserPage(reply.commented_by.user_id)" width="30" height="30" :src="reply.commented_by.user_logo" v-else>
                                            </div>
                                        </div>
                                    </el-popover>
                                    <div class="reply-content">
                                        <div class="user-info">
                                            <span class="user-name ellipsis" @click="goUserPage(reply.commented_by.user_id)">{{reply.commented_by.nick_name}}</span>
                                            <el-tooltip v-if="reply.commented_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                                <svg style="width: 20px; height: 20px" aria-hidden="true">
                                                    <use xlink:href="#icon-lanjingguanfang"></use>
                                                </svg>
                                            </el-tooltip>
                                            <el-tooltip v-if="reply.commented_by.is_vip" effect="light" content="核心用户" placement="right">
                                                <span class="icon-vipuser"></span>
                                            </el-tooltip>
                                            <span class="author" v-if="item.commented_by.user_id === reply.commented_by.user_id">
                                                {{ judgmentIsAuthor(item) ? '作者' : '楼主' }}
                                            </span>
                                            <template v-if="reply.to">
                                                <span class="gray">回复</span>
                                                <span class="user-name ellipsis" @click="goUserPage(reply.to.commented_by.id)">{{reply.to.commented_by.nick_name}}</span>
                                                <el-tooltip v-if="reply.to.commented_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                                    <svg style="width: 20px; height: 20px" aria-hidden="true">
                                                        <use xlink:href="#icon-lanjingguanfang"></use>
                                                    </svg>
                                                </el-tooltip>
                                                <el-tooltip v-if="reply.to.commented_by.is_vip" effect="light" content="核心用户" placement="right">
                                                    <span class="icon-vipuser"></span>
                                                </el-tooltip>
                                                <span class="gray">的回答</span>
                                                <p style="display: none;" :class="`hidden-text-${reply.id}`" v-html="filterXSS(reply.to.comment)"></p>
                                                <p
                                                    class="gray title"
                                                    @mouseenter="handlerMouseEnter(reply)"
                                                    @mouseleave="handlerMouseLeave(reply)"
                                                    @click="scrollIntoReply(reply)">
                                                    “ <span v-html="filterXSS(reply.toCommentText)" class="text ellipsis"></span> ”
                                                </p>
                                            </template>
                                        </div>
                                        <div :class="['comment', {'active': reply.isActive, 'comment-height': reply.showMore}]">
                                            <p class="reply-value" style="word-break: break-word;" v-html="filterXSS(reply.comment)" @click.stop="getImgUrl($event)"></p>
                                            <p
                                                class="put-away fixed-bottom"
                                                :style="getCommentCollapsePos()"
                                                v-if="fixedCommentId === reply.id"
                                                @click="getMoreComment(item.id, reply.id)">
                                                收起
                                                <i class="el-icon-arrow-up"></i>
                                            </p>
                                        </div>
                                        <div :class="['reply-footer', {'active': reply.isActive}]">
                                            <p class="footer-left">
                                                <span
                                                    :class="['reply', {'is-disabled': reply.replyShowType === 'edit'}]"
                                                    @click="onCommentReply(reply)">
                                                    {{ reply.isCommentReply && reply.replyShowType === 'comment' ? '收起回复' : '回复' }}
                                                </span>
                                                <template v-if="reply.is_mine">
                                                    <span
                                                        :class="['delete', {'is-disabled': reply.isQuote || reply.isCommentReply }]"
                                                        @click="deleteReply(reply)">
                                                        删除
                                                    </span>
                                                    <span
                                                        :class="['edite', {'is-disabled': reply.isQuote || reply.replyShowType === 'comment' }]"
                                                        @click="onEditReply(reply)">
                                                        {{ reply.replyShowType === 'edit' ? '取消编辑' : '编辑' }}
                                                    </span>
                                                </template>
                                            </p>
                                            <span class="time">{{ reply.created_on }}</span>
                                        </div>
                                        <p
                                            :class="['show-more', {'put-away': !reply.showMore}]"
                                            v-if="reply.exceed"
                                            @click="getMoreComment(item.id, reply.id)">
                                            <span>{{ reply.showMore ? '显示更多' : '收起' }}</span>
                                            <i :class="[reply.showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i>
                                        </p>
                                    </div>
                                </div>
                                <reply
                                    v-if="reply.isCommentReply"
                                    :replyInfo="reply"
                                    :userInfo="curUserInfo"
                                    :isAnswer="isAnswer"
                                    :isShow="reply.isAnimation"
                                    @onChangeEditor="onChangeEditor"
                                    @replyComment="replyComment"
                                    @onCancelComment="onCancelComment">
                                </reply>
                            </li>
                        </template>
                        <loading :ifLoadingStart="item.comment_num && item.replyLoading" style="padding: 36px 0;background-color:#ffffff;margin:0;"></loading>
                    </ul>
                </div>
            </li>
            <!-- 加载更多 -->
            <li  class="load-more" @click="doLoadMore()"  v-show="commentListCount > 10 && commentList.length < commentListCount">
                <img v-if="isLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <p v-else>加载更多</p>
            </li>
            <!-- 无数据 -->
            <li class="left-attention-null"  v-if="commentListCount === 0 && !isWriteComment && !isLoading">
                <img src="../../images/developer/null.png" alt="" />
                <p>暂无评论，点击
                    <a href="javascript:;" @click="onWriteComment">抢沙发</a>
                </p>
            </li>
        </ul>
        
        <!-- 底部固定 -->
        <section v-if="isFixed" class="fixed">
            <div class="content-footer" :style="getCommentCollapsePos()">
                <div class="btn-wrap">
                    <p class="smart-button" @click="onWriteComment">
                        <img src="../../images/community/edit.png" alt="">
                        <span>{{ isAnswer ? '添加回答' : '添加评论' }}</span>
                    </p>
                    <el-tooltip v-if="isAnswer" effect="dark" popper-class="follow-tip" :content="detailInfo.is_followed? '取消关注' : '关注'" placement="top">
                        <p :class="['smart-button follow', {'is-followed': detailInfo.is_followed}]" @click="$emit('focusToggle')">
                            <i class="img-icon"></i>
                            <span>{{ detailInfo.is_followed ? '已关注' : '关注' }}</span>
                        </p>
                    </el-tooltip>
                    <el-tooltip v-else effect="dark" popper-class="follow-tip" :content="detailInfo.is_liked? '取消收藏' : '收藏'" placement="top">
                        <p :class="['smart-button favorite', {'is-favorite': detailInfo.is_liked}]" @click="$emit('favoriteToggle', detailInfo)">
                            <i class="img-icon"></i>
                            <span>{{ detailInfo.is_liked ? '已收藏' : '收藏' }}</span>
                        </p>
                    </el-tooltip>
                </div>
                <div class="go-comment" @click="scrollIntoComment">
                    <span>{{ '查看所有 ' + commentListCount + (isAnswer ? '个回答' : '个评论')}}</span>
                    <span class="circle">
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import loading from '../loading.vue';
// 导入编辑器组件
import changeEditor from './wangEditor.vue';
import userCard from '../common/userCard.vue'
// 导入回复模块
import reply from './reply.vue'
import tools from '@/js/tools.js'
import bus from '@/js/bus.js'
export default {
    props: {
        isLogin: {
            type: Boolean,
            default: false
        },
        isAnswer: {
            type: Boolean,
            default: true
        },
        curUserInfo: {
            type: Object,
            default: () => {}
        },
        detailInfo: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        loading,
        changeEditor,
        reply,
        userCard
    },
    data () {
        return {
            putAwayLoading: false,
            isLoading: true,
            isAddCommentLoading: false, // 添加回答loading
            commentListCount: 0, // 评论数量
            commentList: [], // 一级评论列表
            isThrottled: false, // 滚动节流 是否进入cd
            isPageOver: false, // 前端分页加载是否结束
            totalPage: null, // 计算出总共多少页
            pollingTimer: null,
            replyList: {}, // 二级评论列表
            isSubmitLoading: false, // 提交loading
            isWriteComment: false, // 是否添加回答
            commentContent: '', // 回答内容
            editor: '', // 存放实例化的wangEditor对象
            sortList: [
                { value: '时间正序', sort: 'latest' },
                { value: '时间倒序', sort: 'unlatest' },
                { value: '获赞最多', sort: 'hottest' }
            ],
            sortType: 'latest',
            curPage: 1,
            pageSize: 10,
            replyInfo: {},
            expandedComments: [], // 展示更多评论id
            fixedCommentId: null,
            isFixed: false
        }
    },
    watch: {
        '$route': {
            handler (val) {
                if (this.$route.params.wid) {
                    this.initQuestionList(1)
                }
            },
            deep: true
        }
    },
    computed: {
        isAllowComment () {
            let result = false
            if (this.commentContent &&  this.commentContent !== '<p><br></p>') {
                result = true
            }
            return result
        }
    },
    async created () {
        await this.initQuestionList(1)
        this.$nextTick(() => {
            this.setFooterFixed()
        })
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取提问详细内容
        async initQuestionList (page, isLoadMore) {
            this.isLoading = true
            let requestUrl = `forum/comment/?topic_id=${this.$route.params.wid}&page=${page}&sort=${this.sortType}&page_size=${this.pageSize}`
            
            await axios.get(myUrl + requestUrl).then(res => {
                if (!res.data.result) return
                this.isLoading = false
                const {data} = res.data
                this.commentListCount = data.count
                this.totalPage = Math.ceil(data.count / this.pageSize) || 1
                this.isPageOver = this.curPage === this.totalPage
                const commentList = this.handleCommentList(data.results, isLoadMore)
                if (isLoadMore) {
                    this.commentList.push(...commentList)
                } else {
                    this.commentList = commentList
                }
                // 给所有高超过900px的评论设置显示更多
                setTimeout(() => {
                    this.answerFn()
                    this.setCommentShowMore()
                }, 500)
            }).catch(error => {
                this.isLoading = false
                console.warn(error)
            })
        },
        // 根据外层点击类型设置不同交互
        async answerFn () {
            const commentWrapper = Boolean(localStorage.getItem('commentWrapper'))
            const commentId = Number(localStorage.getItem('commentId'))
            if (commentId) {
                this.scrollIntoSpecifyComment(Number(commentId))
            } else if (commentWrapper) {
                this.scrollIntoComment()
            }
            localStorage.removeItem('commentWrapper')
            localStorage.removeItem('commentId')
        },

        // 给所有高超过900px的评论设置显示更多
        setCommentShowMore () {
            const commentsDom = document.querySelectorAll('.comment-content > .comment')
            commentsDom.forEach((dom, index) => {
                const height = dom.getBoundingClientRect().height
                if (height > 900) {
                    this.commentList[index].exceed = true
                    this.commentList[index].showMore = true
                }
            })
        },
        // 一级评论列表
        handleCommentList (data) {
            const commentList = data.map(item => {
                item.comment = tools.setImgCustomAttr(item.comment)
                this.$set(item, 'replyContent', '') // 回复内容
                this.$set(item, 'replyShow', false) // 是否展示回复
                this.$set(item, 'isShowEditor', false) // 是否展示富文本
                this.$set(item, 'isSubmitLoading', false) // 提交回复loading
                this.$set(item, 'replyLoading', false) // 是否在加载子回复
                this.$set(item, 'exceed', false) // 评论是否超出
                this.$set(item, 'showMore', false) // 评论是否显示更多
                this.$set(item, 'fixedBottom', false) // 超出评论是否吸底
                this.$set(item, 'commentShowType', '') // 是否为回复/编辑类型
                return item
            })
            return commentList
        },
        // 判断是否为作者
        judgmentIsAuthor (val) {
            let result = false
            if (val) {
                result = val.commented_by.user_id === this.detailInfo.created_by.user_id
            }
            return result
        },
        // 富文本value改变事件
        onChangeEditor (val, domId, parentId) {
            if (domId === 'commentEditor') {
                this.commentContent = val
            } else {
                const commentId = domId.split('replyEditor')[1]
                const commentList =  parentId ? this.replyList[parentId] : this.commentList
                const replyItem = commentList.find(item => item.id === Number(commentId))
                replyItem.replyContent = val
            }
        },
        // 内容过长设置吸底
        setFooterFixed () {
            const contentDom = document.querySelector('.center-top-content')
            const contentHeight = contentDom.getBoundingClientRect().height
            this.isFixed = contentHeight > 900
        },
        // 调转到评论区
        scrollIntoComment () {
            const contentDom = document.querySelector('.center-top-content')
            const contentHeight = contentDom.getBoundingClientRect().height
            $('html,body').animate({
                scrollTop: contentHeight + 25
            }, 500)
        },
        // 跳转到个人中心
        goUserPage (userId) {
            // 判断是否为自己或者他人
            const isMatch = this.curUserInfo.user_id === userId
            const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userId}`
            let routeData = this.$router.resolve({
                path
            });
            window.open(routeData.href, '_blank');
        },
        // 赞同评论
        agreeInfo (item) {
            if (this.isLogin) {
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup');
                    return;
                }
                let params = {
                    action: item.is_vote_up ? 'down' : 'up',
                    parent_id: item.id
                }
                axios.post(myUrl + 'forum/usercomment/', qs.stringify(params)).then(res => {
                    if (item.is_vote_up) {
                        item.vote_up_num--
                    } else {
                        item.vote_up_num++
                    }
                    item.is_vote_up = !item.is_vote_up
                })
            } else {
                this.onLogin()
            }
        },
        // 添加回答
        onWriteComment () {
            if (this.isLogin) {
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup');
                    return;
                }
                this.scrollIntoComment()
                this.isWriteComment = true
            } else {
                this.onLogin()
            }
        },
        // 取消评论
        onCancelComment (comment) {
            if (comment) {
                if (comment.commentShowType === 'edit' && !comment.parent_id) {
                    comment.commentShowType = ''
                    comment.replyShow = false
                    this.replyInfo = {}
                } else if (!comment.parent_id) {
                    comment.isShowEditor = false
                } else {
                    this.cancelReply(comment)
                }
                comment.replyContent = ''
            } else {
                this.isWriteComment = false
                this.commentContent = ''
            }
        },
        // 添加回复
        onConfirmComment () {
            if (!this.isAllowComment) return
            if (this.isAddCommentLoading) return
            this.isAddCommentLoading = true
            let params = {
                parent_id: '0',
                comment: this.commentContent,
                topic_id: this.detailInfo.id
            }
            axios.post(myUrl + 'forum/comment/', qs.stringify(params)).then(res => {
                if (!res.data.result) return
                // 添加数据在评论区
                const comment = res.data.data
                this.commentList.unshift(comment)
                this.commentList = this.handleCommentList(this.commentList)

                this.commentContent = ''
                this.isWriteComment = false
                this.commentListCount += 1
                this.$message({
                    message: '回复成功！',
                    type: 'success'
                })
                this.isAddCommentLoading = false
                this.detailInfo.no_of_comment += 1
                // 给所有高超过900px的评论设置显示更多
                this.setCommentShowMore()
            }) .catch(error => {
                console.warn(error)
                this.isAddCommentLoading = false
            })
        },
        // 采纳/取消采纳
        onSwitchAccept (item) {
            const accept = !item.is_accept
            const acceptIndex = this.commentList.findIndex(comment => comment.is_accept)
            if (accept && acceptIndex > -1) {
                this.$bkInfo({
                    title: '已有答案被采纳。如需要替换，原采纳回答将被取消。确定替换吗？',
                    confirmFn: () => {
                        this.onAccept(item.id, accept)
                    }
                })
            } else {
                this.onAccept(item.id, accept)
            }
        },
        // 采纳方法
        onAccept (id, accept) {
            this.commentList.forEach(comment => {
                comment.is_accept = comment.id === id ? accept : false
            })
            const msg = accept ? '采纳成功' : '取消采纳成功'
            let params = {
                is_accept: accept,
                parent_id: id
            };
            axios.post(myUrl + 'forum/usercomment/', qs.stringify(params))
            // 提醒父级更新帖子详情
            this.$emit('onSwitchAccept')
            
            this.$message({
                message: msg,
                type: 'success'
            })
        },
        // 切换排序类型
        onSwitchSort (item) {
            this.sortType = item.sort
            this.totalPage = 0
            this.curPage = 1
            this.initQuestionList(1)
        },
        // 删除评论
        deleteComment (comment) {
            if (comment.commentShowType || comment.comment_num) return
            this.$bkInfo({
                title: '是否删除该评论?',
                confirmFn: () => {
                    this.confirmDeleteComment(comment)
                }
            })
        },
        // 删除回调
        confirmDeleteComment (comment) {
            const questionId = comment.id;
            axios.delete(myUrl + `forum/comment/${questionId}/`).then(res => {
                if (!res.data.result) return;
                const index = this.commentList.findIndex(item => item.id === questionId)
                this.commentList.splice(index, 1)
                this.detailInfo.no_of_comment -= 1
                this.commentListCount -= 1
                this.$message({
                    message: '删除成功',
                    type: 'success'
                })
            });
        },
        // 编辑评论
        onEditComment (comment) {
            if (comment.commentShowType === 'comment' || comment.comment_num) return
            if (comment.commentShowType === 'edit') {
                // 判断是否是有修改
                if (comment.comment !== comment.replyContent) {
                    this.$bkInfo({
                        title: '是否保存修改?',
                        confirmFn: () => {
                            this.confirmEditComment(comment)
                        },
                        cancelFn: () => {
                            comment.commentShowType = ''
                            comment.replyShow = false
                            this.replyInfo = {}
                        }
                    })
                    return
                }
                comment.commentShowType = ''
                comment.replyShow = false
                this.replyInfo = {}
            } else {
                comment.commentShowType = 'edit'
                comment.replyShow = true
                this.replyInfo = comment
                comment.isShowEditor = true
                comment.replyContent = comment.comment
            }
        },
        // 编辑评论回调
        confirmEditComment (reply) {
            try {
                const params = {
                    comment: reply.replyContent,
                    parent_id: reply.id,
                    topic_id: reply.topic_id
                }
                axios.put(myUrl + `forum/comment/${reply.id}/`, params).then(res => {
                    if (!res.data.result) return
                    const comment = this.commentList.find(item => item.id === reply.id)
                    comment.commentShowType = ''
                    comment.replyShow = false
                    this.replyInfo = {}
                    comment.comment = res.data.data.comment
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    })
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 鼠标移入用户回答的标题
        handlerMouseEnter (reply, enter = true) {
            const toReply = reply.to
            this.replyList[reply.parent_id].forEach(val => {
                if (val.id === toReply.id) {
                    val.isActive = enter
                }
            })
        },
        // 鼠标移出用户回答的标题
        handlerMouseLeave (reply) {
            this.handlerMouseEnter(reply, false)
        },
        // 滚动到指定的评论
        scrollIntoSpecifyComment (commentId) {
            const index = this.commentList.findIndex(comment => comment.id === commentId)
            const commentDom = document.querySelectorAll('.comment-item')[index]
            if (commentDom) {
                $('html,body').animate({
                    scrollTop: commentDom.offsetTop - 130
                }, 500)
            }
        },
        // 滚动到指定的回复
        scrollIntoReply (reply) {
            const index = this.commentList.findIndex(comment => comment.id === reply.parent_id)
            const commentDom = document.querySelectorAll('.comment-item')[index]
            const replyDoms = commentDom && commentDom.querySelectorAll('.reply-item')
            const replyList = this.replyList[reply.parent_id]
            const replyIndex = replyList.findIndex(val => val.id === reply.to.id)
            const targetDom = replyDoms && replyDoms[replyIndex]
            if (targetDom) {
                $('html,body').animate({
                    scrollTop: targetDom.offsetTop + commentDom.offsetTop - 130
                }, 500)
            }
        },
        // 评论回复
        onCommentReply (reply) {
            if (this.putAwayLoading) return
            this.putAwayLoading = true
            if (reply.isCommentReply) {
                reply.isAnimation = false
                setTimeout(() => {
                    reply.isCommentReply = false
                    this.putAwayLoading = false
                    reply.replyShowType = ''
                }, 600)
                return
            }
            if (!reply.replyShowType) {
                reply.replyShowType = 'comment'
            }
            const questionId = reply.id
            this.replyList[reply.parent_id].forEach(item => {
                if (item.id === questionId) {
                    item.isCommentReply = true
                    this.$nextTick(() => {
                        item.isAnimation = true
                    })
                } else {
                    item.isAnimation = false
                    if (item.isCommentReply) {
                        setTimeout(() => {
                            item.isCommentReply = false
                        }, 600)
                    }
                }
            })
            setTimeout(() => {
                this.putAwayLoading = false
            }, 600)
        },
        // 删除回复
        deleteReply (reply) {
            if (reply.isQuote || reply.replyShowType) return
            this.$bkInfo({
                title: '是否删除该回复?',
                confirmFn: () => {
                    this.confirmDeleteReply(reply)
                }
            })
        },
        // 删除回调
        confirmDeleteReply (reply) {
            const questionId = reply.id;
            axios.delete(myUrl + `forum/comment/${questionId}/`).then(res => {
                if (!res.data.result) return;
                const parentId = reply.parent_id
                const index = this.replyList[parentId].findIndex(item => item.id === questionId)
                this.replyList[parentId].splice(index, 1);
                const comment = this.commentList.find(comment => comment.id === parentId)
                comment.comment_num = comment.comment_num - 1
                // 重新获取所有指向id
                const idList = new Set()
                this.replyList[parentId].forEach(item => {
                    item.to && idList.add(item.to.id)
                })
                this.replyList[parentId].forEach(item => {
                    this.$set(item, 'isQuote', [...idList].includes(item.id))
                })
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
            });
        },
        // 编辑回复
        onEditReply (reply) {
            if (reply.isQuote || reply.replyShowType === 'comment') return
            if (reply.replyShowType === 'edit') {
                // 判断是否是有修改
                if (reply.comment !== reply.replyContent) {
                    this.$bkInfo({
                        title: '是否保存修改?',
                        confirmFn: () => {
                            this.confirmEditReply(reply)
                        },
                        cancelFn: () => {
                            this.cancelReply(reply)
                        }
                    })
                    return
                }
                this.cancelReply(reply)
            } else {
                reply.replyShowType = 'edit'
                reply.replyContent = reply.comment
                this.onCommentReply(reply)
            }
        },
        // 编辑回复回调
        confirmEditReply (reply) {
            try {
                const params = {
                    comment: reply.replyContent,
                    parent_id: reply.parent_id,
                    topic_id: reply.topic_id
                }
                axios.put(myUrl + `forum/comment/${reply.id}/`, params).then(res => {
                    if (!res.data.result) return
                    const replyInfo = this.replyList[reply.parent_id].find(item => item.id === reply.id)
                    replyInfo.replyShowType = ''
                    replyInfo.comment = res.data.data.comment
                    this.cancelReply(replyInfo)
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    })
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 取消回复
        cancelReply (replyInfo) {
            replyInfo.isAnimation = false
            setTimeout(() => {
                replyInfo.isCommentReply = false
                this.putAwayLoading = false
                replyInfo.replyShowType = ''
            }, 600)
        },
        // 显示更多
        getMoreComment (commentId, replyId) {
            let commentInfo = this.commentList.find(item => item.id === commentId)
            if (replyId) {
                commentInfo = this.replyList[commentId].find(item => item.id === replyId)
                this.scrollIntoReply({
                    parent_id: commentId,
                    to: {
                        id: replyId
                    }
                })
            }
            commentInfo.showMore = !commentInfo.showMore
            if (commentInfo.showMore) {
                this.onCollapseCommentItem(commentInfo.id)
                const idIndex = this.expandedComments.findIndex(id => id === commentInfo.id)
                this.expandedComments.splice(idIndex, 1)
            } else {
                this.expandedComments.push(commentInfo.id)
            }
            // 滚动时根据评论高度来设置吸底效果
            this.$nextTick(() => {
                this.handleScroll()
            })
        },
        // 收起单条评论内容，显示更多详情按钮
        onCollapseCommentItem (id) {
            const index = this.commentList.findIndex(item => item.id === id)
            const el = document.querySelector(`.comment${id}`)
            const height = el.getBoundingClientRect().top
            const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            window.scrollTo({
                top: height + scrollTop - 130
            })
        },
        // 收起单条回复内容，显示更多详情按钮
        onCollapseReplyItem (reply) {
            reply.showMore = !reply.showMore
            this.scrollIntoReply({
                parent_id: reply.parent_id,
                to: {
                    id: reply.id
                }
            })
        },
        // 滚动事件
        handleScroll () {
            // 处理单条评论“收起”栏的吸底效果
            let fixedId = ''
            this.expandedComments.some(id => {
                const el = document.querySelector(`.comment${id}`)
                if (el) {
                    const contentEl = el.querySelector('.comment')
                    const { top, bottom, height } = contentEl.getBoundingClientRect()
                    // const index = this.commentList.findIndex(item => item.id === id)
                    // this.commentList[index].fixedBottom = false
                    // "收起"栏吸底需要满足条件：
                    // 评论内容高度超过视口高度；评论内容在视口范围内；评论顶部距视口底部距离超过 200 px
                    if (height > window.innerHeight && bottom > window.innerHeight && top < window.innerHeight - 200) {
                        fixedId = id
                        return true
                    }
                }
            })
            this.fixedCommentId = fixedId

            // 文章内容底部吸底
            const commentsTop = $('.comment-wrapper').offset().top
            const documentScroll = $(document).scrollTop()
            const differ = commentsTop - documentScroll - window.innerHeight;
            this.isFixed = differ > 0

            // 滚动加载
            if (!this.isPageOver && !this.isThrottled && !this.isLoading) {
                this.isThrottled = true
                this.pollingTimer = setTimeout(() => {
                    this.isThrottled = false
                    const scrollHeight = document.documentElement.scrollHeight
                    const innerHeight = window.innerHeight
                    const scrollY = window.scrollY
                    const height = 80 + 320 // 320 footer的高度
                    if (scrollHeight - innerHeight - scrollY < height) {
                        this.isInitial = false
                        clearTimeout(this.pollingTimer)
                        // 加载更多
                        this.curPage++
                        this.pageSize = 10
                        this.initQuestionList(this.curPage, true)
                    }
                }, 200)
            }
        },
        // 获取吸底“收起”栏的位置坐标
        getCommentCollapsePos () {
            const commentEl = document.querySelector('.comment-wrapper')
            const commentWrapperLeft = commentEl.getBoundingClientRect().left
            return { left: `${commentWrapperLeft}px` }
        },
        // 点击评论条数，展开二级评论列表 
        async getReplyList (item) {
            if (!this.isLogin) {
                this.onLogin()
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            if (item.commentShowType === 'edit') return
            if (item.replyShow) {
                this.replyList[item.id] && this.replyList[item.id].forEach(reply => {
                    reply.isAnimation = false
                    reply.isCommentReply = false
                })
                this.commentList.some(comment => {
                    if (comment.id === item.id) {
                        comment.isShowEditor = false
                    }
                })
                item.replyShow = false
                item.commentShowType = ''
                return
            }
            try {
                item.replyShow = true
                item.commentShowType = 'comment'
                this.replyInfo = item
                item.replyLoading = true
                // 有评论先展示二级评论
                if (item.comment_num) {
                    this.$set(this.replyList, item.id, [])
                    await axios.get(myUrl + `forum/comment/${item.id}/?page=1&page_size=99`).then(res => {
                        if (!res.data.result) return
                        // 获取所有指向id
                        const idList = new Set()
                        res.data.data.child.forEach(item => {
                            item.to && idList.add(item.to.id)
                        })
                        // 添加数据
                        res.data.data.child.forEach(element => {
                            element.comment = tools.setImgCustomAttr(element.comment)
                            this.$set(element, 'isQuote', [...idList].includes(element.id)) // 当前回复是否被引用
                            this.$set(element, 'isCommentReply', false) // 是否评论回答里面的回复
                            this.$set(element, 'isSubmitLoading', false) // 提交回复loading
                            this.$set(element, 'isAnimation', false) // 展示动画
                            this.$set(element, 'replyContent', '') // 评论回复内容
                            this.$set(element, 'exceed', false) // 评论是否超出
                            this.$set(element, 'showMore', false) // 评论是否显示更多
                            this.$set(element, 'isActive', false) // 是否选中
                            this.$set(element, 'replyShowType', '') // 是否为编辑/评论类型
                            this.$set(element, 'toCommentText', '')
                            this.replyList[element.parent_id].push(element)
                            this.$nextTick(() => {
                                const hiddenTextDom = document.querySelector(`.hidden-text-${element.id}`)
                                element.toCommentText = hiddenTextDom && hiddenTextDom.textContent
                            })
                        })
                    })
                    // 给所有高超过600px的回复设置显示更多
                    setTimeout(() => {
                        this.setReplyShowMore(item.id)
                    }, 500)
                }
            } catch (error) {
                console.warn(error)
            } finally {
                item.replyLoading = false
            }
        },
        // 给所有高超过600px的回复设置显示更多
        setReplyShowMore (id) {
            const replyList = this.replyList[id]
            const index = this.commentList.findIndex(comment => comment.id === id)
            const commentDom = document.querySelectorAll('.comment-item')[index]
            let replyDoms = commentDom && commentDom.querySelectorAll('.reply-item')
            replyDoms && replyDoms.forEach((dom, index) => {
                const commentDom = dom.querySelector('.comment')
                const height = commentDom.getBoundingClientRect().height
                if (height > 600) {
                    replyList[index].exceed = true
                    replyList[index].showMore = true
                }
            })
        },
        // 获取回复用户的信息
        getReplyInfo (reply) {
            this.replyInfo = reply
        },
        // 去登录
        onLogin () {
            axios.get(myUrl + 'login/test/')
        },
        /*
            回复评论
            cid: 评论id
        */
        replyComment (reply) {
            if (this.isLogin) {
                // 没有内容不允许提交
                if (!reply.replyContent || !Boolean(reply.replyContent.trim())) {
                    this.$message({
                        message: '请输入评论内容',
                        type: 'warning'
                    })
                    return
                }
                // 单独对评论执行编辑逻辑
                if (reply.commentShowType === 'edit') {
                    this.confirmEditComment(reply)
                    return
                }
                // 单独对回复执行编辑逻辑
                if (reply.replyShowType === 'edit') {
                    this.confirmEditReply(reply)
                    return
                }
                const parentId = reply.parent_id || reply.id
                let params = {
                    parent_id: parentId,
                    // 二级评论内容
                    comment: reply.replyContent,
                    topic_id: this.detailInfo.id
                }
                if (reply.parent_id) {
                    params.to_id = reply.id
                }

                if (reply.isSubmitLoading) return
                reply.isSubmitLoading = true
                axios.post(myUrl + 'forum/comment/', qs.stringify(params)).then(res => {
                    if (!res.data.result) return

                    // 防止重复提交
                    reply.isSubmitLoading = false;
                    reply.comment_num = reply.comment_num + 1
                    reply.replyContent = ''

                    if (!this.replyList.hasOwnProperty(parentId)) {
                        this.$set(this.replyList, parentId, [])
                    }
                    const respData = res.data.data
                    respData.comment = tools.setImgCustomAttr(respData.comment)
                    this.$set(respData, 'isCommentReply', false) // 是否评论回答里面的回复
                    this.$set(respData, 'isSubmitLoading', false) // 提交回复loading
                    this.$set(respData, 'isAnimation', false) // 展示动画
                    this.$set(respData, 'replyContent', '') // 评论回复内容
                    this.$set(respData, 'exceed', false) // 评论是否超出
                    this.$set(respData, 'showMore', false) // 评论是否显示更多
                    this.$set(respData, 'isActive', false) // 是否选中
                    this.$set(respData, 'isQuote', false) // 当前回复是否被引用
                    this.$set(respData, 'toCommentText', '')
                    if (reply.parent_id) {
                        const index = this.replyList[parentId].findIndex(val => val.id === reply.id)
                        this.replyList[parentId].splice(index + 1, 0, respData)
                        reply.isAnimation = false
                        setTimeout(() => {
                            reply.isCommentReply = false
                            reply.isQuote = true
                            reply.replyShowType = ''
                        }, 600)
                    } else {
                        this.replyList[parentId].unshift(respData)
                    }
                    this.$nextTick(() => {
                        const hiddenTextDom = document.querySelector(`.hidden-text-${respData.id}`)
                        respData.toCommentText = hiddenTextDom && hiddenTextDom.textContent
                    })
                    const comment = this.commentList.find(comment => comment.id === parentId)
                    comment.isShowEditor = false
                    this.$message({
                        message: '回复成功！',
                        type: 'success'
                    });
                    // 给所有高超过600px的回复设置显示更多
                    setTimeout(() => {
                        this.setReplyShowMore(reply.id)
                    }, 500)
                }) .catch(error => {
                    console.warn(error)
                    reply.isSubmitLoading = false;
                })
            } else {
                this.onLogin()
            }
        },
        judgeTextLength (editorText, editorHtml) {
            let editorValueLength = this.getByteLen(editorText.replace(/&nbsp;/gi, '').replace(/<br>/gi, '').trim())
            // 没有输入，全空格的情况
            if (editorHtml === `<p><br></p>` || editorHtml === '' || editorText.replace(/&nbsp;/gi, '').replace(/<br>/gi, '').trim() === '') {
                this.$message({
                    message: '请至少输入8个字符！',
                    type: 'warning'
                })
                return false
            }
            if (editorValueLength < 16) {
                this.$message({
                    message: '请至少输入8个字符！',
                    type: 'warning'
                })
                return false
            }
            return true
        },
        getByteLen (str) {
            let reg = /[\u4E00-\u9FA5]/;
            let len = 0;
            str = str.replace(/(^\s+)|(\s+$)/g, '').replace(/\s/g, ''); // 去掉前后空格
            for (var i = 0; i < str.length; i++) {
                if (reg.test(str[i])) len += 2;
                else len += 1;
            }
            return len;
        },
        getImgUrl (event) {
            if (event.target.tagName.toUpperCase() === 'IMG') {
                let href = event.target.currentSrc
                if (href.indexOf('file') !== -1) {
                    href = href.replace('file', 'cos-website.ap-shanghai')
                }
                if (/\.(png|jpg|gif|jpeg|bmp|webp)(\/)?$/i.test(href)) {
                    window.open(href, '_blank')
                }
            }
        },
        getTime (stringTime) {
            let minute = 1000 * 60
            let hour = minute * 60
            let day = hour * 24
            let week = day * 7
            let month = day * 30
            let time1 = new Date().getTime() // 当前的时间戳
            let time2 = Date.parse(new Date(stringTime)) // 指定时间的时间戳
            let time = time1 - time2
            let result = null
            if (time / month >= 1) {
                result = parseInt(time / month) + '月前'
            } else if (time / week >= 1) {
                result = parseInt(time / week) + '周前'
            } else if (time / day >= 1) {
                result = parseInt(time / day) + '天前'
            } else if (time / hour >= 1) {
                result = parseInt(time / hour) + '小时前'
            } else if (time / minute >= 1) {
                result = parseInt(time / minute) + '分钟前'
            } else {
                result = '刚刚'
            }
            return result
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/scrollbar.scss';
    .comment-editor, .reply-editor {
        height: 162px;
        .w-e-toolbar {
            height: 42px;
            line-height: 32px;
            .w-e-menu {
                height: 37px;
            }
            &:first-child .w-e-droplist {
                height: 150px !important;
                overflow-y: auto;
                @include scrollbar;
            }
        }
        .w-e-text-container {
            height: 120px !important;
            background: #fff;
            .w-e-text {
                min-height: 120px !important;
            }
        }
    }
    .comment-list {
        .el-loading-mask {
            z-index: 99999 !important;
            .el-loading-spinner {
                top: 200px !important;
            }
        }
    }
    .comment-value, .reply-value {
        p img {
            max-width: 100%
        }
    }
</style>
<style lang="scss" scoped>
    .comment-wrapper {
        width: 830px;
        padding: 25px 24px;
        background: #fff;
        .smart-button {
            width: 120px;
            height: 32px;
            background: #3a84ff;
            color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-bottom: 17px;
            img {
                height: 28px;
                width: 28px;
            }
            &:hover {
                background: #699df4;
            }
        }
        .all-answer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 27px;
            font-size: 16px;
            color: #313238;
            .answer-num {
                position: relative;
                top: 1px;
            }
            .sort-list {
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #979ba5;
                >li {
                    margin-left: 20px;
                    cursor: pointer;
                    position: relative;
                    &.active,
                    &:hover {
                        color: #313238;
                    }
                    &:not(:first-child)::before {
                        content: '';
                        width: 1px;
                        height: 12px;
                        position: absolute;
                        top: 3px;
                        left: -10px;
                        background: #979ba5;
                    }
                }
                
            }
        }
        .comment-list{
            min-height: 300px;
            .comment-item{
                display: flex;
                margin-bottom: 20px;
                &:last-child{
                    margin-bottom: 0;
                }
                .user-avatar{
                    margin-right: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img {
                        height: 46px;
                        width: 46px;
                        border-radius: 50%;
                        cursor: pointer;
                    }
                    .approval {
                        height: 40px;
                        width: 40px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: #f0f1f5;
                        border-radius: 2px;
                        font-size: 12px;
                        line-height: 16px;
                        margin-top: 7px;
                        cursor: pointer;
                        .num {
                            color: #313238;
                            font-weight: 500;
                            margin-top: 4px;
                        }
                        &.active {
                            .num {
                                color: #3a84ff;
                            }
                            background: #e1ecff;
                            color: #3a84ff;
                        }
                    }
                }
                .comment-content {
                    width: 728px;
                    font-size: 12px;
                    position: relative;
                    .user-info {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        margin: 10px 0;
                        .nick-name {
                            font-size: 14px;
                            color: #313238;
                            line-height: 19px;
                            cursor: pointer;
                            font-weight: 700;
                        }
                        .adopted {
                            width: 44px;
                            height: 18px;
                            text-align: center;
                            line-height: 16px;
                            border: 1px solid #14a568;
                            color: #14a568;
                            margin-left: 8px;
                        }
                        .author {
                            flex-shrink: 0;
                            width: 44px;
                            height: 22px;
                            text-align: center;
                            line-height: 20px;
                            color: #3a84ff;
                            border: 1px solid rgba(58,132,255,0.30);
                            background: #edf4ff;
                            border-radius: 3px;
                            margin-left: 8px;
                            font-size: 12px;
                        }
                    }
                    .comment {
                        font-size: 14px;
                        color: #63656e;
                        line-height: 24px;
                        margin-bottom: 10px;
                        position: relative;
                        &.comment-height {
                            height: 500px;
                            overflow: hidden;
                            margin-bottom: 20px;
                        }
                    }
                    .show-more {
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0px;
                        height: 39px;
                        line-height: 39px;
                        text-align: center;
                        font-size: 14px;
                        color: #3a84ff;
                        background: #fff;
                        cursor: pointer;
                        &.put-away {
                            position: relative;
                        }
                    }
                    .fixed-bottom {
                        position: fixed;
                        bottom: 0;
                        width: 830px;
                        height: 59px;
                        line-height: 59px;
                    }
                    .comment-footer {
                        display: flex;
                        align-items: center;;
                        justify-content: space-between;
                        font-size: 12px;
                        padding-bottom: 12px;
                        border-bottom: 1px solid #f0f1f5;
                        .interact{
                            display: flex;
                            align-items: center;
                            color: #3a84ff;
                            p{
                                cursor: pointer;
                                .number{
                                    font-family: Arial, Helvetica, sans-serif;
                                    margin-left: 5px;
                                    i {
                                        position: relative;
                                        top: 1px;
                                        font-style: initial;
                                    }
                                }
                            }
                            .reply {
                                display: flex;
                                align-items: center;
                            }
                            .cancel-adoption, .delete-comment, .edite-comment {
                                margin-left: 10px;
                            }
                            .is-disabled {
                                cursor: not-allowed;
                                color: #ccc;
                            }
                        }
                        .time {
                            color: #979ba5;
                        }
                    }
                    .reply-list{
                        width: 100%;
                        padding: 14px 0 0;
                        .comment-reply {
                            margin-bottom: 20px;
                            .input-div {
                                display: flex;
                                height: 32px;
                                img {
                                    border-radius: 50%;
                                    margin-right: 9px;
                                }
                                .input {
                                    width: 694px;
                                    height: 32px;
                                    border: 1px solid #dcdee5;
                                    border-radius: 3px;
                                    padding-left: 12px;
                                    cursor: pointer;
                                    font-size: 12px;
                                    color: #c4c6cc;
                                    line-height: 30px;
                                }
                            }
                        }
                        .reply-item{
                            margin-bottom: 8px;
                            .reply-box {
                                display: flex;
                            }
                            .reply-user-avatar{
                                margin-right: 10px;
                                img {
                                    border-radius: 50%;
                                    cursor: pointer;
                                }
                            }
                            .reply-content{
                                width: 692px;
                                border-bottom: 1px solid #f0f1f5;
                                font-size: 12px;
                                position: relative;
                                p {
                                    .nick-name {
                                        margin-left: 5px;
                                        font-weight: 400;
                                    }
                                }
                                .comment {
                                    color: #63656e;
                                    line-height: 24px;
                                    padding: 5px 6px 10px 4px;
                                    transition: all .2s;
                                    .put-away {
                                        color: #3a84ff;
                                        cursor: pointer;
                                        text-align: center;
                                        margin-top: 5px;
                                        font-size: 14px;
                                        background: #fff
                                    }
                                    &.active {
                                        background: rgba(255, 246, 231, 1);
                                    }
                                    &.comment-height {
                                        height: 300px;
                                        overflow: hidden;
                                    }
                                }
                                .user-info{
                                    font-size: 14px;
                                    margin: 3px 0 0;
                                    line-height: 19px;
                                    .user-name {
                                        cursor: pointer;
                                        font-weight: 500;
                                        color: #313238;
                                        flex-shrink: 0;
                                        max-width: 150px;
                                    }
                                    .gray {
                                        flex-shrink: 0;
                                        color: #979ba5;
                                        margin: 0 5px;
                                    }
                                    .title {
                                        flex: 1;
                                        padding: 3px 20px 3px 3px;
                                        margin-left: 2px;
                                        cursor: pointer;
                                        display: flex;
                                        overflow: hidden;
                                        .text {
                                            max-width: 400px;
                                        }
                                        &:hover {
                                            background: #f0f1f5;
                                        }
                                    }
                                    .ellipsis {
                                        overflow:hidden;
                                        text-overflow:ellipsis;
                                        white-space:nowrap;
                                    }
                                }
                                .reply-footer {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    padding: 0 6px 15px 4px;
                                    transition: all .2s;
                                    .footer-left {
                                        display: flex;
                                        align-items: center;
                                        margin: 0;
                                        .reply, .delete, .edite {
                                            cursor: pointer;
                                            color: #3a84ff;
                                            margin-right: 10px;
                                        }
                                        .is-disabled {
                                            cursor: not-allowed;
                                            color: #ccc;
                                        }
                                    }
                                    &.active {
                                        background: rgba(255, 246, 231, 1);
                                    }
                                }
                            }
                        }
                        
                        li:nth-of-type(2) {
                            margin-top: 0;
                        }
                    }
                    &.show-replay > .reply-list {
                        .comment {
                            margin-bottom: 0;
                        }
                    }
                }
                &.my-comment {
                    .nick-name {
                        margin: 10px 0;
                        color: #313238;
                        font-weight: 700;
                    }
                    .send-msg{
                        margin-top: 14px;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        .cancel-btn, .comment-btn {
                            height: 32px;
                            line-height: 32px;
                            text-align: center;
                            border-radius: 2px;
                            cursor: pointer;
                        }
                        .cancel-btn {
                            width: 68px;
                            border: 1px solid #c4c6cc;
                            border-radius: 3px;
                            color: #63656e;
                            margin-right: 8px;
                        }
                        .comment-btn {
                            width: 86px;
                            color: #fff;
                            background: #3a84ff;
                            &.disabled{
                                background: #dcdee5;
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }
        }
        .load-more {
            margin-top: 84px;
            width: 100%;
            text-align: center;
            color: #979ba5;
            font-size: 12px;
            cursor: pointer;
        }
        .fixed {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 50px;
            line-height: 50px;
            background: #ffffff;
            border-top: 1px solid #dcdee5;
            .content-footer {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 830px;
                padding: 0 9px 0 20px;
                .btn-wrap {
                    display: flex;
                    align-items: center;
                    .smart-button {
                        margin-bottom: 0;
                    }
                    .follow, .favorite {
                        width: 110px;
                        margin-left: 20px;
                        background: #fff;
                        border: 1px solid #c4c6cc;
                        color: #63656e;
                        .img-icon {
                            position: relative;
                            display: inline-block;
                            height: 16px;
                            width: 16px;
                            margin-right: 5px;
                            &::before, &::after {
                                content: '';
                                height: 16px;
                                width: 16px;
                                position: absolute;
                                z-index: 1;
                                display: none;
                            }
                        }
                        &:hover {
                            border-color: #979ba5;
                        }
                    }
                    .follow {
                        .img-icon {
                            background-image: url('../../images/community/like3.png');
                            background-size: 100% 100%;
                            &::before {
                                background-image: url('../../images/community/like4.png');
                                background-size: 100% 100%;
                            }
                            &::after {
                                background-image: url('../../images/community/like5.png');
                                background-size: 100% 100%;
                            }
                        }
                        &:hover {
                            color: #3a84ff;
                            .img-icon::before {
                                display: block;
                                z-index: 3;
                            }
                        }
                        &.is-followed {
                            color: #3a84ff;
                            .img-icon::after {
                                display: block;
                                z-index: 3;
                            }
                        }
                    }
                    .favorite {
                        .img-icon {
                            background-image: url('../../images/community/favorite3.png');
                            background-size: 100% 100%;
                            &::before {
                                background-image: url('../../images/community/favorite4.png');
                                background-size: 100% 100%;
                            }
                            &::after {
                                background-image: url('../../images/community/favorite2.png');
                                background-size: 100% 100%;
                            }
                        }
                        &:hover {
                            color: #3a84ff;
                            .img-icon::before {
                                display: block;
                                z-index: 3;
                            }
                        }
                        &.is-favorite {
                            color: #3a84ff;
                            .img-icon::after {
                                display: block;
                                z-index: 3;
                            }
                        }
                    }
                }
                .go-comment {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .circle {
                        height: 18px;
                        width: 18px;
                        border-radius: 50%;
                        border: 1px solid #dcdee5;
                        text-align: center;
                        margin-left: 9px;
                        i {
                            font-size: 13px;
                            position: relative;
                            top: -17px;
                            color: #979ba5;
                        }
                    }
                    &:hover {
                        color: #3a84ff;
                        .circle {
                            border-color: #3a84ff;
                            i {
                                color: #3a84ff;
                            }
                        }
                    }
                }
            }
        }
        .left-attention-null {
            width: 100%;
            box-sizing: border-box;
            text-align: center;
            padding: 135px 0;
            background-color: #ffffff;
            >p {
                color: #878996;
                font-size: 14px;
                margin-top: 25px;
                a {
                    color: #3a84ff;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// comment.vue?2ed1122c